export class HrPerAttachmentKey {
    private static readonly keyPrefix = 'hrPerAttachment';
    public static title = `${HrPerAttachmentKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerAttachmentKey.keyPrefix}.pageHeader`;
    public static file = `${HrPerAttachmentKey.keyPrefix}.file`;
    public static fileName = `${HrPerAttachmentKey.keyPrefix}.fileName`;
    public static fileType = `${HrPerAttachmentKey.keyPrefix}.fileType`;
    public static createdAt = `${HrPerAttachmentKey.keyPrefix}.createdAt`;
    public static show = `${HrPerAttachmentKey.keyPrefix}.show`;
    public static loadFile = `${HrPerAttachmentKey.keyPrefix}.loadFile`;
    public static fileUploadError = `${HrPerAttachmentKey.keyPrefix}.fileUploadError`;
}
